import styled from "styled-components";

export default styled.table`
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;
  ${({ extraStyles }) => extraStyles}
`;
